export default "__VITE_ASSET__BfoEmh0N__"